import * as actionTypes from '../constants/actionTypes';
export function addToHoverStack(_a) {
    var id = _a.id, screenID = _a.screenID, layerID = _a.layerID, scrollPos = _a.scrollPos, maintainScroll = _a.maintainScroll, coordinates = _a.coordinates;
    return {
        type: actionTypes.ADD_TO_HOVER_STACK,
        hoverOutInfo: {
            id: id,
            screenID: screenID,
            layerID: layerID,
            scrollPos: scrollPos,
            maintainScroll: maintainScroll,
            coordinates: coordinates,
        },
    };
}
export function removeFromHoverStack(numberOfLevels) {
    return {
        type: actionTypes.REMOVE_FROM_HOVER_STACK,
        numberOfLevels: numberOfLevels,
    };
}
export function hoverOut(numberOfLevels, scrollPos, eventMeta) {
    return {
        type: actionTypes.HOVER_OUT,
        numberOfLevels: numberOfLevels,
        scrollPos: scrollPos,
        meta: eventMeta,
    };
}
